<template>
  <div>
    <ca-row class="label-reset">
      <ca-col size="3">
        <ca-field label="Tipo de jornada">
          <ca-select
            v-model="journeyType.name"
            :on-open="onOpenJourneyTypeSelect"
            @change="onJourneyTypeChange">
            <ca-option
              v-for="type in misc.journeyTypes"
              :key="type.name"
              :value="type.name">
              {{ type.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col>
        <worker-shift-table
          v-if="isWeeklyJourney"
          :shift-info="shiftInfo"
          :is-draft="isDraft"
          @clear-weekly-hours="setEmptyWeeklyHours"
          @shift-added="setShiftInfo"
          @shift-deleted="setShiftInfo">
        </worker-shift-table>

        <variable-shift-select
          v-else
          v-model="variableShift.workshiftId"
          :refresh-form="refreshForm"
          @input="onChangeVariableShift"></variable-shift-select>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col size="4">
        <ca-field label="Quantidade de horas semanais">
          <ca-input
            v-model="shiftInfo.weeklyHours"
            mask-pattern="99:99"
            required
            :custom-validations="durationValidation"
            :disabled="isWeeklyJourney">
          </ca-input>
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import WorkerShiftTable from './ShiftTable';
import VariableShiftSelect from './VariableShiftSelect';
import { isWeeklyJourney } from '../workerShiftInfoService';

export default {
  name: 'WorkerShiftInfoForm',
  components: {
    WorkerShiftTable,
    VariableShiftSelect,
  },
  props: {
    isDraft: {
      type: Boolean,
      default: false,
    },
    shiftInfo: Object,
    variableShift: Object,
    journeyType: Object,
  },
  data() {
    return {
      hasOpenedJourneyTypeSelect: false,
      durationValidation: [{
        message: 'Formato de horas incompleto',
        valid(value) {
          return value.length === 5;
        },
      }],
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    isWeeklyJourney() {
      return isWeeklyJourney(this.journeyType);
    },
  },
  created() {
    this.$store.dispatch('misc/getJourneyTypes');
  },
  methods: {
    setEmptyWeeklyHours() {
      this.shiftInfo.weeklyHours = null;
    },
    onChangeVariableShift(value) {
      this.shiftInfo.associatedWorkshifts = [{
        weekDay: { name: 'V' },
        workshift: { id: value },
      }];
    },
    onOpenJourneyTypeSelect() {
      this.hasOpenedJourneyTypeSelect = true;
    },
    onJourneyTypeChange() {
      this.$emit('refresh-form');

      if (this.hasOpenedJourneyTypeSelect) {
        this.shiftInfo.associatedWorkshifts = [];
        this.shiftInfo.weeklyHours = null;
        this.variableShift.workshiftId = null;
      }

      if (this.isWeeklyJourney) {
        this.setShiftInfo();
      }
    },
    setShiftInfo() {
      this.$emit('set-shift-info');
    },
    async refreshForm() {
      await this.$nextTick();
      this.$emit('refresh-form');
    },
  },
};
</script>

<style scoped>
.label-reset >>> label:last-child {
  display: unset;
}
</style>
